import type { ProductVariant } from "../types/product";
import { formatEuro, cn } from "../lib/utils";

interface VariantPickerProps {
	variants: ProductVariant[];
	selectedId: string | null;
	onSelect: (variant: ProductVariant) => void;
	className?: string;
}

/** Scelta del formato (250 g, 500 g, 1 kg) con il prezzo di ciascuno. */
export default function VariantPicker({ variants, selectedId, onSelect, className }: VariantPickerProps) {
	return (
		<div role="radiogroup" aria-label="Formato" className={cn("flex flex-wrap gap-2", className)}>
			{variants.map((variant) => {
				const selected = variant.id === selectedId;
				const soldOut = variant.stock <= 0;
				return (
					<button
						key={variant.id}
						type="button"
						role="radio"
						aria-checked={selected}
						disabled={soldOut}
						onClick={() => onSelect(variant)}
						className={cn(
							"min-w-24 rounded-lg border px-4 py-2 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
							selected
								? "border-primary bg-primary/10 text-foreground ring-1 ring-primary"
								: "border-border bg-card text-foreground hover:border-primary/60",
							soldOut && "cursor-not-allowed opacity-50 hover:border-border",
						)}
					>
						<span className="block font-semibold">{variant.label}</span>
						<span className="block text-sm text-muted-foreground">
							{soldOut ? "Esaurito" : formatEuro(variant.price)}
						</span>
					</button>
				);
			})}
		</div>
	);
}
